import React from "react";
import { FormattedMessage } from "react-intl";
import cn from "classnames";
import { useDispatch } from "react-redux";

import { ISingingData, ITaskEditorProps } from "../../../../../../common/types";
import { ICheckboxEvent } from "../../../../../types";
import { editTask } from "../../../../../store/plan/actions";
import { post } from "../../../../../actions/general";

import { setItem, hasItem } from "../../../../../cookie";

import ScoreEditor from "../../../../Score";
import { Checkbox } from "../../../../Form";

import EditorBar, { FlexLeft, FlexRight, Center, Changer } from "../../../EditorBar";

import getScale from "../../Common/getScale";
import getScore from "../../Common/getScore";
import getTempo from "../../Common/getTempo";
import AudioUploader from "../../Common/AudioUploader";
import ChangeScale from "../../Common/ChangeScale";
import ChangeTempo from "../../Common/ChangeTempo";
import useExerciseEditor from "../../Common/useExerciseEditor";
import ChangeColor from "../../Common/ChangeColor";

import messages from "./messages";

const SingingEditor = ({ taskIndex, plan, toggleInlineEditor, publicView, inlineEditorOpen }: ITaskEditorProps) => {
    const dispatch = useDispatch();
    const {
        openChanger,
        playable,
        handleChangeOpen,
        setPopupRef,
        storeScore,
        changeTempo,
        setPlayable,
        exportScore,
    } = useExerciseEditor({ plan, inlineEditorOpen, taskIndex });
    const changeIsMale = ({ target: { checked } }: ICheckboxEvent) => {
        dispatch(editTask({ taskIndex, changingProp: "isMale", val: checked }));
        dispatch(post("singing-change-is-male", {
            planId: plan._id,
            index: taskIndex,
            isMale: checked,
        }));
    };

    const task = plan.tasks[taskIndex];
    const data = task.data as ISingingData;
    const forwardProps = {
        plan,
        taskIndex,
        openChanger,
        handleChangeOpen,
        setPopupRef,
    }
    return (
        <div>
            {inlineEditorOpen && (
                <ScoreEditor
                    score={JSON.parse(JSON.stringify(getScore(plan, task) || {}))}
                    scale={getScale(plan, task)}
                    tempo={getTempo(plan, task)}
                    taskType="singing"
                    setScore={storeScore}
                    changeTempo={changeTempo}
                />
            )}
            {!publicView && (
                <EditorBar>
                    <FlexLeft>
                        {task?.data && <ChangeScale {...forwardProps} />}
                        <Changer>
                            <Checkbox
                                dark
                                label={<FormattedMessage {...messages.maleOctave} />}
                                checked={data.isMale || false}
                                onChange={changeIsMale}
                            />
                        </Changer>
                        <AudioUploader plan={plan} taskIndex={taskIndex} />
                    </FlexLeft>
                    <Center
                        disabled={(inlineEditorOpen && !playable)}
                        tooltip={!playable && inlineEditorOpen && <FormattedMessage {...messages.createScoreTooltip} />}
                        onClick={() => {
                            toggleInlineEditor(!inlineEditorOpen);
                            setPlayable(true);
                            if (inlineEditorOpen) {
                                exportScore();
                            }
                            setItem("rhytNameDone", "1", 60 * 60 * 24 * 365, "/");
                        }}
                        className={cn(
                            !(inlineEditorOpen && !playable) && !hasItem("rhytNameDone") && !task.ref && "pulsate"
                        )}
                    >
                        {inlineEditorOpen ? (
                            <FormattedMessage {...messages.stopEdit} />
                        ) : (
                            <FormattedMessage {...messages.editScore} />
                        )}
                    </Center>
                    <FlexRight>
                        <ChangeTempo {...forwardProps} />
                        <ChangeColor
                            {...forwardProps}
                            color={task.data?.color}
                        />
                    </FlexRight>
                </EditorBar>
            )}
        </div>
    );
}

export default SingingEditor;
